import * as searchboxReducer from "./reducer.js";
import { configureStore } from "@reduxjs/toolkit";
const getInitialState = () => ({
    searchbox: searchboxReducer.getInitialState()
});
const store = configureStore({
    reducer: {
        searchbox: searchboxReducer.reducer
    },
    preloadedState: getInitialState(),
    devTools: { name: "Redux store - Searchbox" }
});
export { store, getInitialState };
